import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {keyDisplayName} from '../../../../util/runs';
import {useMediaSliderKey} from '../../../PanelMediaBrowser/hooks/useMediaSliderKey';
import {SettingTitle} from './common/SettingTitle';
import {useMediaSettingsDrawerContext} from './MediaSettingsDrawerContextProvider';

export const SliderSync = () => {
  const {config, updateConfig, unsetConfigField, settingsLevel} =
    useMediaSettingsDrawerContext();
  const sliderSyncKey = useMediaSliderKey(config.mediaSliderKey);
  const sliderSyncKeyDisplayName = keyDisplayName({
    section: 'summary',
    name: sliderSyncKey,
  });
  const [isChecked, setIsChecked] = useState(config.sliderSync === true);
  return (
    <div className="flex justify-between">
      <SettingTitle
        title={`Sync slider by key (${sliderSyncKeyDisplayName})`}
        configField="sliderSync"
        unsetConfigField={() => unsetConfigField('sliderSync')}
        description={`Adjusting one slider updates others in this ${settingsLevel} using the same key (${sliderSyncKeyDisplayName})`}
      />
      <Switch.Root
        aria-label="Toggle slider sync"
        data-test="slider-sync-switch"
        checked={isChecked}
        onCheckedChange={newIsChecked => {
          setIsChecked(newIsChecked);
          // Allow the switch to animate before updating the config so that it's more of a smooth
          // transition before the component re-mounts
          setTimeout(() => {
            updateConfig({sliderSync: newIsChecked});
          }, 100);
        }}>
        <Switch.Thumb checked={isChecked} />
      </Switch.Root>
    </div>
  );
};
